import React from 'react';

import { JsonLd } from 'react-schemaorg';
import { FinancialService } from 'schema-dts';

/**
 * Renders the JSON-LD For FinancialService
 *
 */
export function FinancialServiceJsonLd() {
  return (
    <JsonLd<FinancialService>
      item={{
        '@context': 'https://schema.org',
        '@type': 'FinancialService',
        description:
          'Naked is the new way to cover your stuff. Insurance for your car, home and other possessions, with unprecedented user-control, value for money and customer fairness at its core.',
        image: Config.Web.Links.NAKED_WEB_LOGO,
        name: 'Naked Insurance',
        telephone: '+27860 995 125',
        logo: Config.Web.Links.NAKED_WEB_LOGO,
        url: Config.Web.Links.NAKED_WEB_URL,
        priceRange: 'RR',
        address: {
          '@type': 'PostalAddress',
          addressCountry: 'ZA',
          addressLocality: 'Johannesburg',
          addressRegion: 'Gauteng',
          postalCode: '2193',
          streetAddress: '9 Gordon Hill',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: -26.1727199,
          longitude: 28.0415541,
        },
      }}
    />
  );
}
